var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.styles && _vm.styles.icons)?_c('span',_vm._l((_vm.styles.icons),function(icon,index){return _c('v-icon',{key:index,attrs:{"color":icon.iconColour && _vm.palette[icon.iconColour]
                ? _vm.palette[icon.iconColour].hex
                : ''}},[_vm._v(" "+_vm._s(icon.iconCode)+" ")])}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }